import { useMemo } from "react";
import { Transaction } from "../../types/budgethelper";
import { FilterState, getTimePeriodRange } from "../../types/filterTypes";
import { formatDateKey } from "../utils/formatters";

export const useTransactionFilters = (
  transactions: Transaction[],
  filterState: FilterState
) => {
  const filteredTransactions = useMemo(() => {
    return transactions.filter((transaction) => {
      // Category filter
      const categoryMatch = filterState.selectedCategory === null || 
                           transaction.category === filterState.selectedCategory;
      
      // Budget group filter
      const budgetGroupMatch = filterState.selectedBudgetGroups.size === 0 || 
                              (transaction.budgetGroup && filterState.selectedBudgetGroups.has(transaction.budgetGroup));
      
      // Time period filter
      const { startTime, endTime } = getTimePeriodRange(filterState.timePeriod);
      const txTime = transaction.timestamp.toDate().getTime();
      const timeMatch = txTime >= startTime && txTime <= endTime;
      
      return categoryMatch && budgetGroupMatch && timeMatch;
    });
  }, [transactions, filterState]);

  const groupedTransactions = useMemo(() => {
    return filteredTransactions.reduce((groups, transaction) => {
      const date = formatDateKey(transaction.timestamp);
      if (!groups[date]) groups[date] = [];
      groups[date].push(transaction);
      return groups;
    }, {} as Record<string, Transaction[]>);
  }, [filteredTransactions]);

  const totalSpending = useMemo(() => {
    return filteredTransactions.reduce((sum, t) => sum + t.amount, 0);
  }, [filteredTransactions]);

  return {
    filteredTransactions,
    groupedTransactions,
    totalSpending,
  };
};
